/**
 * @param {number} periodYear
 * @param {number} periodMonth 1-12
 * @param {number} diaProgramado 1-31
 * @param {number} desfaseMes meses después del período contable
 */
export const getFechaPagoExacta = (
  periodYear,
  periodMonth,
  diaProgramado,
  desfaseMes = 0
) => {
  let targetMonth = periodMonth + desfaseMes;
  let targetYear = periodYear;

  while (targetMonth > 12) {
    targetMonth -= 12;
    targetYear += 1;
  }
  while (targetMonth < 1) {
    targetMonth += 12;
    targetYear -= 1;
  }

  const lastDay = new Date(targetYear, targetMonth, 0).getDate();
  const day = Math.min(diaProgramado, lastDay);
  return new Date(targetYear, targetMonth - 1, day).toISOString();
};

export const formatDesfaseMes = (desfaseMes) => {
  if (!desfaseMes) return "mismo mes";
  if (desfaseMes === 1) return "+1 mes";
  return `+${desfaseMes} meses`;
};

const MONTH_NAMES = [
  "ene",
  "feb",
  "mar",
  "abr",
  "may",
  "jun",
  "jul",
  "ago",
  "sep",
  "oct",
  "nov",
  "dic",
];

export const debeGenerarInstancia = (plantilla, targetMonth) => {
  const frecuencia = plantilla.frecuencia ?? "mensual";
  if (frecuencia === "anual") {
    const mesPago = plantilla.mesPago;
    if (mesPago == null || mesPago < 1 || mesPago > 12) return false;
    return targetMonth === mesPago;
  }
  return true;
};

export const getFechaPagoExactaFromPlantilla = (
  periodYear,
  periodMonth,
  plantilla
) => {
  const dia = plantilla.diaProgramado ?? 1;
  const frecuencia = plantilla.frecuencia ?? "mensual";

  if (frecuencia === "anual") {
    const mes = plantilla.mesPago ?? periodMonth;
    return getFechaPagoExacta(periodYear, mes, dia, 0);
  }

  return getFechaPagoExacta(
    periodYear,
    periodMonth,
    dia,
    plantilla.desfaseMes ?? 0
  );
};

export const formatProgramacionPago = (plantilla) => {
  const frecuencia = plantilla.frecuencia ?? "mensual";
  const dia = plantilla.diaProgramado ?? "?";

  if (frecuencia === "anual") {
    const mes = plantilla.mesPago;
    const mesLabel =
      mes >= 1 && mes <= 12 ? MONTH_NAMES[mes - 1] : "?";
    return `Anual · ${dia}/${mesLabel}`;
  }

  return `Día ${dia} (${formatDesfaseMes(plantilla.desfaseMes ?? 0)})`;
};
